// Leitor de código de barras USB no Balcão (pedido do dono, 29/09/2026 —
// Chiquinho Carnes). A escuta do teclado é compartilhada com o Delivery
// (hooks/useLeitorCodigoBarras); aqui só o que o Balcão faz com o código.
// Regras da etiqueta da balança em lib/codigoBarras.js.
import { toast } from "sonner";

import { useLeitorCodigoBarras } from "../../../hooks/useLeitorCodigoBarras";
import { avisoLeituraNaoEncontrada, identificarLeitura, itemPelaEtiqueta } from "../../../lib/codigoBarras";

const TELAS_QUE_ADICIONAM = ["menu", "cart_review"];

export function useLeitorBalcao({ ativo, screen, products, allProducts, cart, addToCart, comPromocao, abrirProduto, tryOpenPizza, novaVenda }) {
  const lerCodigo = (codigo) => {
    // Bip na tela "Pedido Confirmado" (30/09/2026) é o 1º item do próximo
    // cliente: a próxima venda começa na hora e o item entra no carrinho novo.
    const naConfirmacao = screen === "confirmation";
    if (!naConfirmacao && !TELAS_QUE_ADICIONAM.includes(screen)) {
      toast.info("Volte ao cardápio para adicionar produtos");
      return;
    }
    const r = identificarLeitura(codigo, products);
    if (r.tipo === "nao_encontrado") { toast.error(avisoLeituraNaoEncontrada(r, allProducts, "no Balcão")); return; }
    // O recomeço zera o carrinho antes do item entrar (os setState vão em ordem).
    if (naConfirmacao) novaVenda();
    const noCarrinho = naConfirmacao ? [] : cart;
    const p = r.produto;
    // Etiqueta da balança: valor e peso são os impressos, sem promoção
    // (decisão do dono, 30/09/2026) — `p` vai sem o preço promocional.
    if (r.tipo === "balanca") {
      // A mesma etiqueta pode se repetir (Chiquinho Carnes, 31/10/2026): dois
      // pacotes com o mesmo peso dão o mesmo código (produto + valor, sem número
      // de série). Entra como outra linha; só avisa, para o caixa conferir.
      if (noCarrinho.some((i) => i.etiqueta_balanca === r.codigo)) {
        toast.info(`Etiqueta repetida: mais um ${p.name} de R$ ${Number(r.total).toFixed(2).replace(".", ",")}`);
      }
      addToCart({ ...p, ...itemPelaEtiqueta(p, r.total, r.codigo) });
      return;
    }
    // Bipou = adicionou (pedido do dono, 29/09/2026), mesmo com etapas — o corte
    // do açougue já vem cortado/embalado. Só pizza (tamanho) e combo (escolha)
    // precisam de montagem para existir.
    if (tryOpenPizza(p)) return;
    if (p.product_type === "combo") { abrirProduto(p); return; }
    // Código da embalagem: mesmo preço do card (com a promoção, se houver).
    addToCart({ ...comPromocao(p), quantity: 1 });
  };
  useLeitorCodigoBarras({ ativo, onLeitura: lerCodigo });

  // Código digitado à mão na busca + Enter: mesmo caminho do leitor.
  return { lerCodigo };
}
